import { gql } from "@apollo/client";

export const GET_PUBLICATION_SCHEDULE_QUERY = gql`
  query GetPublicationSchedule($ticketId: ID!, $tenantId: String) {
    getPublicationSchedule(ticketId: $ticketId, tenantId: $tenantId) {
      schedule {
        effectiveDay
        scheduledFor
        platform
        assetId
        itemLabel
        scheduleName
        videoId
        ticketId
        processedVideoTicketId
        assetType
      }
      ticketId
      tenantId
    }
  }
`;
